<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modal-ndescuentoaprob">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center"> <b>Aprobar/Rechazar Descuento</b> </h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button> -->
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12 mb-0 pb-0">
                           <p class="mb-0"> <b>Programa:</b> {{datas.programa}} </p>
                        </div>
                        <div class="col-sm-6 mt-0 pt-0" v-if="descuento.monto">
                            <p class="mb-0 mt-0"> <b>Concepto:</b> {{descuento.concepto_pago.nombre}} </p>
                            <p class="mb-0"> <b>Monto de descuento:</b> {{descuento.monto}} Bs. </p>
                            <p class="mb-0"> <b>Prorrateo:</b> {{descuento.prorrateadoActivo?'SI':'NO'}} </p>
                            <p class="mb-0"> <b>Estado:</b> {{descuento.estado}} </p>
                            <p class="mb-1"> <b>Descripcion:</b> {{descuento.descripcion}} </p>
                            <p class="mb-1"> <b>Estudiante:</b> {{datas.nombres}} {{datas.primer_apellido}} </p>

                            <b class="blue--text"> <span class="text-danger">*</span> Seleccionar Estado: </b>
                            <select v-model="estado" class="form-control">
                                <option value="aprobado"> Aprobado </option>
                                <option value="rechazado"> Rechazado </option>
                            </select>
                        </div>
                        <div class="col-sm-6 mt-0 pt-0" v-if="estado=='rechazado'">
                            <b> Escriba una respuesta: </b>
                            <textarea v-model.trim="respuesta" class="form-control" cols="30" rows="4" placeholder="Escriba la respuesta de rechazo...."></textarea>
                        </div>
                    </div>

                    <p class="text-center text-danger"> <b>{{msg}}</b> </p>
                    <div class="text-center">
                        <div style="display: inline-block;" v-show="loading" class="loader"></div>
                    </div>

                    <div class="xcard">
                        <b class="blue--text"> Para continuar escriba: <span class="red--text">{{estado}}</span> para proceder. </b>
                        <input type="text" class="form-control" v-model="proceder_text">

                        <div class="text-right mt-1">
                            <button @click="validarCampos()" :disabled="loading || !proceder_text || proceder_text!=estado" type="button" class="btn btn-azul white--text mr-2">Responder</button>
                            <button type="button" class="btn btn-secondary black--text" data-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getheadersrest} from '@/components/Utils';
    export default {
        data(){
            return{
                area:{nombre:null},
                descuento: {},
                loading: false,
                msg: '',
                estado: '',
                respuesta: '',
                proceder_text: '',

                datas:{ nombres:'' },
            }
        },
        watch:{},
        components:{},
        methods:{
            setdescuento( desc ){
                this.descuento = desc;
                this.msg = '';
                this.estado = '';
                this.respuesta = '';
                this.proceder_text = '';
                this.loading = false;
                this.datas = {nombres:''};
                this.getinscripcion( desc );
                //window.console.log( desc );
            },
            validarCampos(){
                if( !this.estado ) { this.msg = 'Seleccione un estado.'; return; }
                if( !this.respuesta && this.estado == 'rechazado' ) { this.msg = 'Escriba una respuesta indicando el rechazo'; return; }
                let data = {
                    "estado": this.estado,
                    "id": this.descuento.id,
                    "respuesta": this.respuesta
                }
                if( !this.respuesta ) delete data.respuesta;
                this.enviarrespuesta( data );
            },
            enviarrespuesta( data ){
                this.msg = '';
                const vue = this;
                vue.loading = true;
                let myHeaders = getheadersrest();
                const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/descuentos/respuesta`;
                window.console.log(data);

                fetch(url, {
                    headers: myHeaders,
                    method: 'PUT',
                    body: JSON.stringify(data)
                }).then((res) => {
                    window.console.log('RES: ',res, res.body);
                    //vue.msg = res.data.data;
                    vue.loading = false;
                    if( res.status == 200 ){
                        setTimeout(()=>{ window.$('#modal-ndescuentoaprob').modal('hide'); },300);
                        vue.$emit('onrespuesta');
                    }
                }).catch(error => {
                    window.console.error(error);
                    vue.msg = error;
                    vue.loading = false;
                });
            },
            getinscripcion(desc) {
                const vue = this;
                vue.datas.nombres = desc.estudiante.nombres;
                vue.datas.primer_apellido = desc.estudiante.primer_apellido;
                vue.datas.segundo_apellido = desc.estudiante.segundo_apellido;
                vue.datas.numero_documento = desc.estudiante.numero_documento;

                vue.datas.programa = desc.programa.nombre;
            },
        },
        mounted(){
          var vue = this;
          window.$('#modal-ndescuentoaprob').on('hide',function(){ vue.area.nombre=null;vue.estado=true; });
        }
    
    }
</script>